import {
  DTOAnalyzeCodeComponentsInPackageInput,
  DTOAnalyzeCodeComponentsInPackageResponse,
  DTOCodeComponentListResponse,
  DTOCodeComponentsCreateInput,
  DTOCodeComponentUpsertResponse,
} from "../../../dto";
import { RequestExecutor } from "../../../transport/request-executor";

export class CodeComponentsEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  async import(dsId: string, vId: string, body: DTOCodeComponentsCreateInput) {
    return this.requestExecutor.json(
      `/design-systems/${dsId}/versions/${vId}/code-components`,
      DTOCodeComponentUpsertResponse,
      {
        body,
        method: "POST",
      }
    );
  }

  async list(dsId: string, vId: string) {
    return this.requestExecutor.json(
      `/design-systems/${dsId}/versions/${vId}/code-components`,
      DTOCodeComponentListResponse
    );
  }

  async deleteAll(dsId: string, vId: string) {
    return this.requestExecutor.json(
      `/design-systems/${dsId}/versions/${vId}/code-components`,
      DTOCodeComponentListResponse,
      {
        method: "DELETE",
      }
    );
  }

  async analyzePackage(dsId: string, vId: string, body: DTOAnalyzeCodeComponentsInPackageInput) {
    return this.requestExecutor.json(
      `/design-systems/${dsId}/versions/${vId}/code-components/analyze-package`,
      DTOAnalyzeCodeComponentsInPackageResponse,
      {
        body,
        method: "POST",
      }
    );
  }
}
